import { Box, Text } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../utils/datahooks';
export const RuleElementListHeader = _ref => {
  let {
    title,
    totalSize,
    completedSize,
    dataHook
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.ruleElementListHeader(dataHook),
    gap: "3px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    dark: true,
    secondary: true
  }, `(${completedSize}/${totalSize})`));
};
//# sourceMappingURL=rule-element-list-header.js.map